import React from "react"
import PropTypes from "prop-types"
import { GatsbySeo } from "gatsby-plugin-next-seo"
import {generateSeoFromDocument} from "@utils/seo"
import {getUriFromDocument, getAbsoluteUrl} from "@utils/routing"
import { useSiteSettingsStore } from "@src/hooks/useStore"

function SEO({ document, includeTitleSuffix = true }) {
  const { siteSettings } = useSiteSettingsStore(["siteSettings"]);

  const siteBaseUrl = getAbsoluteUrl()

  let config = generateSeoFromDocument(siteSettings, {canonical: siteBaseUrl})

  if (document) {
    const canonical = getAbsoluteUrl(getUriFromDocument(document, true))
    config = Object.assign({
      ...generateSeoFromDocument(document, {
        includeTitleSuffix,
        canonical,
      }, config),
      canonical,
    })
  }

  return <GatsbySeo {...config} />
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
